/* eslint-disable */
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import AuthReducer from './AuthSlice';
import CurriculumReducer from './CurriculumSlice';
import TopicReducer from './TopicSlice';
import SubTopicReducer from './SubTopicSlice';
import QuestionReducer from './QuestionSlice';
import TagsReducer from './TagsSlice';
import QuizReducer from './QuizSlice';
import SubmissionReducer from './SubmissionSlice';
import TrialReducer from './Trial';
import StudentReducer from './StudentSlice';
import UsersReducer from './UserSlice';
import ResourcesReducer from './ResourcesSlice';
import LoaderReducer from './LoaderSlice';
import ConfigReducer from './ConfigSlice';
import ErrorReducer from './ErrorSlice';
import SuccessReducer from './SuccessSlice';
import BookmarkReducer from './BookmarkSlice';
import SessionReducer from './SessionSlice';
import ProgressReducer from './ProgressSlice';
import DiagnosticReducer from './DiagnosticSlice';
import StripeReducer from './StripeSlice';
import AccessLimitReducer from './AccessLimitSlice';
import GptQuestionGenerateReducer from './GptQuestionGenerateSlice';
import AnalyticsReducer from './AnalyticsSlice';
import StructuredEssayQuestionReducer from './StructuredEssayQuestionSlice';
// V2
import CurriculumReducerV2 from './V2/CurriculumSlice';
import CoursesReducer from './V2/CoursesSlice';
import CourseTutorsReducer from './V2/CourseTutorsSlice';
import CourseStudentsReducer from './V2/CourseStudentsSlice';
import SectionsReducer from './V2/SectionSlice';
import SavingReducer from './V2/SavingSlice';
import StripeReducerV2 from './V2/StripeSlice';
import QuiztopiyaReducer from './V2/QuiztopiyaSlice';
import CourseTemplatesReducer from './V2/CourseTemplatesSlice';
import CourseHoursRangeReducer from './V2/CourseHoursRangeSlice';
import SectionTemplatesReducer from './V2/SectionTemplateSlice';
import ReportIssueReducer from './V2/ReportIssueSlice';
import MeetingRequestsReducer from './V2/MeetingRequestsSlice';
import UserAvailabilityReducer from './V2/UserAvailabilitySlice';
import ScheduleReducer from './V2/ScheduleSlice';
import SubjectReducer from './V2/SubjectSlice';
import LessonHistoryReducer from './V2/LessonHistorySlice';
import LessonStudentFeedbacksReducer from './V2/LessonStudentFeedbacksSlice';
import LessonTutorFeedbacksReducer from './V2/LessonTutorFeedbacksSlice';
import SettingsReducer from './V2/SettingsSlice';
import TrialsReducer from './V2/TrialsSlice';
import HomeworksReducer from './V2/HomeworksSlice';
import PaymentHistoryReducer from './V2/PaymentHistorySlice';
import TransactionLogsReducer from './V2/TransactionLogsSlice';
import InvoicesReducer from './V2/InvoicesSlice';
import OneToOneTutorRateVersionsReducer from './V2/OneToOneTutorRateVersionsSlice';
import TutorRateStudentTypesReducer from './V2/OneToOneTutorRateStudentTypesSlice';
import OneToOneTutorRatesReducer from './V2/OneToOneTutorRatesSlice';
import GroupTutorRateVersonsReducer from './V2/GroupTutorRateVersionsSlice';
import GroupTutorRateCourseTypesReducer from './V2/GroupTutorRateCourseTypesSlice';
import GroupTutorRatesReducer from './V2/GroupTutorRatesSlice';
import FlexiblePlansReducer from './V2/FlexiblePlansSlice';
import SubscriptionPlansReducer from './V2/SubscriptionPlansSlice';
import GroupsReducer from './V2/GroupsSlice';
import CoursePermissionTemplatesReducer from './V2/CoursePermissionTemplatesSlice';
import StudentFlexibleRateVersionsReducer from './V2/StudentFlexibleRateVersionsSlice';
import StudentFlexibleRatesReducer from './V2/StudentFlexibleRatesSlice';
import StudentSubscriptionRateVersionsReducer from './V2/StudentSubscriptionRateVersionsSlice';
import StudentSubscriptionRatesReducer from './V2/StudentSubscriptionRatesSlice';
import CoursePricingTemplatesReducer from './V2/CoursePricingTemplatesSlice';
import RolesReducer from './V2/RolesSlice';
import ChatReducer from './V2/ChatSlice';
import AdminChatReducer from './V2/AdminChatSlice';
import ChatSocketMiddleware from '../chat/chatSocketMiddleware';
import adminChatSocketMiddleware from '../chat/adminChatSocketMiddleWare';
import TutorsReducer from './V2/TutorSlice';
import MetaTagsReducer from './V2/MetaTagsSlice';
import RedirectionsReducer from './V2/RedirectionsSlice';
import PenaltyWaiverReducer from './V2/PenaltyWaiverSlice';
import SitemapReducer from './V2/SitemapSlice';
import ProgressReducerV2 from './V2/ProgressSlice';
import ManualAdjustmentsReducer from './V2/ManualAdjustmentsSlice';
import SubmissionReducerV2 from './V2/SubmissionsSlice';
import TenantsReducer from './V2/TenantsSlice';
import OnboardingReducer from './V2/OnboardingSlice';
import TutorSortingReducer from './V2/TutorSortingSlice';
import CallLogsReducer from './V2/CallLogsSlice';
import TutorRolesReducer from './V2/TutorRolesSlice';
import GlobalChatReducer from './V2/GlobalChatSlice';
import WaitingRoomReducer from './V2/WaitingRoomSlice';
import waitingRoomSocketMiddleware from '../waitingRoom/waitingRoomSocketMiddleware';
import CustomQuizReducer from './V2/CustomQuizSlice';
import CustomSubmissionReducer from './V2/CustomSubmissionSlice';

export const store = configureStore({
  reducer: {
    auth: AuthReducer,
    curriculum: CurriculumReducer,
    topic: TopicReducer,
    subTopic: SubTopicReducer,
    question: QuestionReducer,
    tags: TagsReducer,
    quiz: QuizReducer,
    submission: SubmissionReducer,
    trial: TrialReducer,
    students: StudentReducer,
    users: UsersReducer,
    resources: ResourcesReducer,
    config: ConfigReducer,
    loader: LoaderReducer,
    error: ErrorReducer,
    success: SuccessReducer,
    bookmark: BookmarkReducer,
    session: SessionReducer,
    progress: ProgressReducer,
    diagnostic: DiagnosticReducer,
    stripe: StripeReducer,
    access: AccessLimitReducer,
    gptQuestionGenerate: GptQuestionGenerateReducer,
    analytics: AnalyticsReducer,
    structuredEssayQuestion: StructuredEssayQuestionReducer,
    // V2
    courses: CoursesReducer,
    courseTutors: CourseTutorsReducer,
    courseStudents: CourseStudentsReducer,
    sections: SectionsReducer,
    saving: SavingReducer,
    curriculumV2: CurriculumReducerV2,
    stripeV2: StripeReducerV2,
    quiztopiya: QuiztopiyaReducer,
    courseTemplates: CourseTemplatesReducer,
    courseHoursRange: CourseHoursRangeReducer,
    sectionTemplates: SectionTemplatesReducer,
    meetingRequests: MeetingRequestsReducer,
    userAvailability: UserAvailabilityReducer,
    schedule: ScheduleReducer,
    subject: SubjectReducer,
    reportIssue: ReportIssueReducer,
    trials: TrialsReducer,
    lessonHistory: LessonHistoryReducer,
    lessonStudentFeedbacks: LessonStudentFeedbacksReducer,
    lessonTutorFeedbacks: LessonTutorFeedbacksReducer,
    homeworks: HomeworksReducer,
    settings: SettingsReducer,
    paymentHistory: PaymentHistoryReducer,
    transactionLogs: TransactionLogsReducer,
    oneToOneTutorRateVersions: OneToOneTutorRateVersionsReducer,
    tutorRateStudentTypes: TutorRateStudentTypesReducer,
    oneToOneTutorRates: OneToOneTutorRatesReducer,
    invoices: InvoicesReducer,
    groupTutorRateVersions: GroupTutorRateVersonsReducer,
    groupTutorRateCourseTypes: GroupTutorRateCourseTypesReducer,
    groupTutorRates: GroupTutorRatesReducer,
    flexiblePlans: FlexiblePlansReducer,
    subscriptionPlans: SubscriptionPlansReducer,
    groups: GroupsReducer,
    coursePermissionTemplates: CoursePermissionTemplatesReducer,
    studentFlexibleRateVersions: StudentFlexibleRateVersionsReducer,
    studentFlexibleRatesState: StudentFlexibleRatesReducer,
    studentSubscriptionRateVersions: StudentSubscriptionRateVersionsReducer,
    studentSubscriptionRatesState: StudentSubscriptionRatesReducer,
    chat: ChatReducer,
    adminChat: AdminChatReducer,
    coursePricingTemplates: CoursePricingTemplatesReducer,
    roles: RolesReducer,
    tutors: TutorsReducer,
    metaTags: MetaTagsReducer,
    redirections: RedirectionsReducer,
    penaltyWaiver: PenaltyWaiverReducer,
    sitemap: SitemapReducer,
    progressV2: ProgressReducerV2,
    manualAdjustments: ManualAdjustmentsReducer,
    submissionsV2: SubmissionReducerV2,
    tenants: TenantsReducer,
    onboarding: OnboardingReducer,
    tutorSorting: TutorSortingReducer,
    callLogs: CallLogsReducer,
    tutorRoles: TutorRolesReducer,
    globalChat: GlobalChatReducer,
    waitingRoom: WaitingRoomReducer,
    customQuiz: CustomQuizReducer,
    customSubmission: CustomSubmissionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(ChatSocketMiddleware)
      .concat(adminChatSocketMiddleware)
      .concat(waitingRoomSocketMiddleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export default store;
